import { render, staticRenderFns } from "./BaseTrumpetExplain.vue?vue&type=template&id=572c7aa4&scoped=true&"
import script from "./BaseTrumpetExplain.vue?vue&type=script&lang=js&"
export * from "./BaseTrumpetExplain.vue?vue&type=script&lang=js&"
import style0 from "./BaseTrumpetExplain.vue?vue&type=style&index=0&id=572c7aa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572c7aa4",
  null
  
)

export default component.exports